import { FICTION_GENRES } from "../data/constants";

const EMOTION_TAGS_FICTION = {
  "calm-bright":    { emoji: "🌿", label: "잔잔한 위로" },
  "calm-dark":      { emoji: "🌙", label: "깊은 사색" },
  "intense-bright": { emoji: "✨", label: "가슴 뛰는" },
  "intense-dark":   { emoji: "🔥", label: "강렬한 몰입" },
};

/**
 * 비소설 태그.
 *
 * 축 이름(bright / dark, calm / intense)은 소설 기준으로 붙어 있다.
 * 비소설에서는 뜻이 다르게 걸린다 — 표를 채울 때 이걸 놓쳐서
 * 가운데 두 줄의 라벨이 서로 바뀌어 있었다.
 *
 *   bright  = X축 왼쪽  = 가벼움      dark    = X축 오른쪽 = 무거움(깊고)
 *   calm    = Y축 위    = 실용적      intense = Y축 아래   = 사색적
 */
const EMOTION_TAGS_NONFICTION = {
  "calm-bright":    { emoji: "☀️", label: "가볍고 실용적" },
  "calm-dark":      { emoji: "📐", label: "깊고 실용적" },
  "intense-bright": { emoji: "🧭", label: "가볍고 사색적" },
  "intense-dark":   { emoji: "🔮", label: "깊고 사색적" },
};

/**
 * getEmotionTag(book) — 감정 태그 계산
 */
export function getEmotionTag(book) {
  const emotions = book.emotions || {};
  const entries = Object.values(emotions);
  if (entries.length === 0) return null;
  const avgBright = entries.reduce((s, e) => s + e.bright, 0) / entries.length;
  const avgCalm = entries.reduce((s, e) => s + e.calm, 0) / entries.length;
  const isDark = avgBright >= 50;
  const isIntense = avgCalm >= 50;
  const isFiction = FICTION_GENRES.includes(book.genre);
  const tags = isFiction ? EMOTION_TAGS_FICTION : EMOTION_TAGS_NONFICTION;
  const key = `${isIntense ? "intense" : "calm"}-${isDark ? "dark" : "bright"}`;
  const prefix = isFiction ? "f-" : "nf-";
  return { ...tags[key], key: prefix + key };
}

/**
 * filterRealUsers(list) — 시드/게스트 유저 제외
 */
export function filterRealUsers(list) {
  return list.filter(u =>
    u.name && u.handle && u.createdAt &&
    !["r1","r2","r3","r4","guest"].includes(u.id) &&
    u.handle !== "reader"
  );
}
